<template>
   <v-container fluid>
      <v-toolbar dense :color="$globalstore.settings_titleclass">
         <v-toolbar-title>
            <template v-if="$vuetify.breakpoint.mobile">
               <v-icon large class="mr-2" @click="goBack()">mdi-chevron-left</v-icon>
            </template>
            CCA Schedule Master
         </v-toolbar-title>
         <v-spacer></v-spacer>
         <v-btn small outlined class="primary white--text" @click="addSchedule">
            <v-icon small>mdi-plus</v-icon>
            Add
         </v-btn>
      </v-toolbar>
      <v-row class="pt-1 mt-1">
         <v-col cols="12" md="12">
            <v-data-table
               dense
               :headers="schedule_headers"
               :items="scheduledata"
               item-key="id"
               single-select
               @click:row="scheduleRowClick"
            >
               <!-- eslint-disable-next-line -->
               <template #item.actions="{ item }">
                  <v-icon small @click="editSchedule(item)">mdi-pencil</v-icon>
                  <v-icon small @click="removeSchedule(item)" class="ml-2">mdi-delete</v-icon>
               </template>
            </v-data-table>
         </v-col>
      </v-row>
      <cca-schedule-form
         ref="scheduleform"
         :termyear="termyeardata"
         @input="onScheduleFormClose"
      ></cca-schedule-form>
      <confirm-dlg ref="confirm"></confirm-dlg>
      <show-toast ref="toast"></show-toast>
   </v-container>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import CCAScheduleForm from "@/components/CCAScheduleForm.vue";
   import ShowToast from "@/components/showToast.vue";

   export default {
      inject: ["ShowMessage"],

      components: {
         "confirm-dlg": ConfirmDlg,
         "cca-schedule-form": CCAScheduleForm,
         ShowToast,
      },

      data() {
         return {
            schedule_headers: [
               {
                  text: "ID",
                  value: "id",
                  class: this.$globalstore.table_headerclass,
                  width: "6%",
               },
               {
                  text: "Term/Year",
                  value: "termyeartext",
                  class: this.$globalstore.table_headerclass,
                  width: "15%",
               },
               {
                  text: "Name",
                  value: "schedule_name",
                  class: this.$globalstore.table_headerclass,
                  width: "35%",
               },
               {
                  text: "Start",
                  value: "schedule_startdate",
                  class: this.$globalstore.table_headerclass,
                  width: "10%",
               },
               {
                  text: "End",
                  value: "schedule_enddate",
                  class: this.$globalstore.table_headerclass,
                  width: "10%",
               },
               {
                  text: "",
                  value: "actions",
                  class: this.$globalstore.table_headerclass,
                  width: "10%",
               },
            ],
            scheduledata: [],
            termyeardata: this.$globalstore.termyearlist,
         };
      },
      methods: {
         goBack() {
            this.$router.go(-1);
         },

         scheduleRowClick(item, row) {
            row.select(!row.isSelected);
         },

         addSchedule() {
            this.$refs.scheduleform.open();
         },

         editSchedule(schedule) {
            this.$refs.scheduleform.edit(schedule);
         },

         onScheduleFormClose(payload) {
            if (payload.mode == "add") {
               this.doAddSchedule(payload.schedule);
            } else if (payload.mode == "edit") {
               this.doUpdateSchedule(payload.schedule);
            }
         },

         async doAddSchedule(schedule) {
            await this.$http({
               url: "/cca/addschedule.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  schedule: schedule,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.LoadScheduleList();
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         async doUpdateSchedule(schedule) {
            await this.$http({
               url: "/cca/updateschedule.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  schedule: schedule,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.LoadScheduleList();
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         async removeSchedule(item) {
            await this.$refs.confirm
               .open("Warning", "Are you sure you want to delete the selected schedule?", {
                  color: "orange",
               })
               .then((reply) => {
                  if (reply) {
                     this.doRemoveSchedule(item);
                     this.LoadScheduleList();
                  }
               });
         },

         async doRemoveSchedule(schedule) {
            await this.$http({
               url: "/cca/removeschedule.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  schedule: schedule,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.LoadScheduleList();
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         async LoadScheduleList() {
            await this.$http({
               url: "/cca/getschedulemasterlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.scheduledata = response.data.scheduledata;
                  }
               }
            });
         },
      },
      mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.LoadScheduleList();
         }
      },
   };
</script>
